import JsBarcode from 'jsbarcode';

const CodBarras = async (documFra, modeloCodBarras, codBarrasRdo) => {
  // console.log(documFra, modeloCodBarras, codBarrasRdo)
//PARA IMPRIMIR CODIGO DE BARRAS
let factCodBarras = ""
if(modeloCodBarras==="1"){
//ultimo caracter=longitud del prefijo
//=> la referencia queda =>  prefijo factura + numero factura + longitud prefijo factura
//queda de 10 digitos => se completa con ceros a la izquierda            
  let posic1 = documFra.numeroFra.indexOf("-")
  if(posic1===-1){
    factCodBarras = `${documFra.numeroFra}0`
  }else{
    factCodBarras = documFra.numeroFra.substr(posic1 + 1)      
    let prefijoFra = documFra.numeroFra.substr(0, posic1)
    let longPrefijo = prefijoFra.length
    factCodBarras = `${prefijoFra}${factCodBarras}${longPrefijo}`
  }
}
if(modeloCodBarras==="2"){
  factCodBarras = `${documFra.contrato}`
}
//slice => para extraer caracteres de la derecha
let valorCodBarras = `00000000000000${factCodBarras}`
// valorCodBarras = valorCodBarras.slice(-14)
factCodBarras = valorCodBarras.slice(-10)

// factCodBarras = factCodBarras.slice(-24)

// let valorCodBarras = `00000000000000${documFra.valorFactura}`
// valorCodBarras = valorCodBarras.slice(-14)

// console.log(documFra)
// let fechaCodBarras
// if(documFra.pagueHasta){
//   fechaCodBarras = `${documFra.pagueHasta.substr(0,4)}${documFra.pagueHasta.substr(5,2)}${documFra.pagueHasta.substr(8,2)}`
// }else{
//   fechaCodBarras = `${documFra.fechaFact.substr(0,4)}${documFra.fechaFact.substr(5,2)}${documFra.fechaFact.substr(8,2)}`
// }

// factCodBarras =  `000000000000000000000000${documFra.numeroFra}`
// factCodBarras = factCodBarras.slice(-10)
valorCodBarras = `00000000000000${documFra.valorFactura}`
// valorCodBarras = valorCodBarras.slice(-8)
valorCodBarras = valorCodBarras.slice(-10)

// console.log(this.props.empresa, codBarrasRdo)
// let textoCB = `Ê415${codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}Ê96${fechaCodBarras}`
// let textoCBTxt = `(415)${codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}(96)${fechaCodBarras}`
let textoCB = `Ê415${codBarrasRdo}8020${factCodBarras}Ê3900${valorCodBarras}`
let textoCBTxt = `(415)${codBarrasRdo}(8020)${factCodBarras}(3900)${valorCodBarras}`

let canvas = document.createElement("canvas");
// JsBarcode("#barcodecanvasjs", textoCB, {
JsBarcode(canvas, textoCB, {
  format: "CODE128",
  ean128: true,
  text: textoCBTxt,
  lineColor: "#000000",
  width: 2,
  height: 50,
  // width: 2,
  // height: 50,
  displayValue: true
});
// let canvas = document.getElementById('barcodecanvasjs');
let imgSource = canvas.toDataURL("image/png");
//FIN PARA IMPRIMIR CODIGO DE BARRAS

return imgSource

}

export default CodBarras
